
var config = {
  db: {
    options: {
      poolSize: 20,
      useNewUrlParser: true,
      useUnifiedTopology: true,
      maxIdleTimeMS: 30000, // Tiempo máximo en ms que una conexión puede estar inactiva
      connectTimeoutMS: 10000, // Tiempo de espera para conexiones iniciales
      socketTimeoutMS: 45000, // Tiempo de espera para operaciones de red
      // native_parser: true,
      // useMongoClient: true,
      // replset: { rs_name: 'myReplicaSetName' },
      user: 'esacosta',
      pass: 'Che55!!P1a2a_2022'
    },
    options_debug: {
      autoIndex: false, // Don't build indexes
      // reconnectTries: Number.MAX_VALUE, // Never stop trying to reconnect
      // reconnectInterval: 500, // Reconnect every 500ms
      // bufferMaxEntries: 0,
      bufferCommands: false, // Disable mongoose buffering
      useNewUrlParser: true,
      useUnifiedTopology: true,
      poolSize: 20,
      maxIdleTimeMS: 30000, // Tiempo máximo en ms que una conexión puede estar inactiva
      connectTimeoutMS: 10000, // Tiempo de espera para conexiones iniciales
      socketTimeoutMS: 45000 // Tiempo de espera para operaciones de red
      // native_parser: true,
      // useMongoClient: true
      // replset: { rs_name: 'myReplicaSetName' },
      // user: 'superAdmin',
      // pass: 'ChessPlaza2020'
    },
    // uri_debug: process.env.MONGO_URL || 'mongodb://127.0.0.1/ChessPlaza',
    uri_debug: process.env.MONGO_URL || 'mongodb+srv://esacosta:Che55!!P1a2a_2022@clusterbackup.bpmi2.mongodb.net/ChessPlaza',
    uri: process.env.MONGO_URL || 'mongodb+srv://esacosta:Che55!!P1a2a_2022@cluster0.ma8fg18.mongodb.net/ChessPlaza'
  },
  host_uri: 'https://play.mainchess.com',
  host_uri_debug: 'https://localhost',
  stream_uri: 'https://stream.mainchess.com',
  stream_uri_debug: 'https://localhost:2053',
  video_uri: 'https://video.mainchess.com',
  video_uri_debug: 'https://localhost:2083',
  porthttp: process.env.PORT || 2023,
  porthttp_debug: process.env.PORT || 443,
  multicore: false,
  https: true,
  debug: false,
  ipaddr: ''
}
module.exports = config



// WEBPACK FOOTER //
// ./server/config.js